export class Error {
    message: string;
    localizedMessage: string;
    className: string;
    simpleClassName: string;
}